import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as ds from '@attain-apps/fe/web/main/lib/design'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as router from '@attain-apps/fe/web/main/lib/router'

import * as contexts from '../contexts'

import { Api } from './api.service'
import * as effects from './effects'
import type { TypeParams } from './types'

/**
 * Underlying {@link ec.Collection | Collection} for
 * {@link ents.core.admin.Scenario.ForUser | Scenario.ForUser} entities.
 */
@ngCore.Injectable({ providedIn: 'root' })
export class Collection extends ec.Collection<TypeParams> {
  constructor() {
    const _contexts = ngCore.inject(contexts.Feature)
    const _router = ngCore.inject(router.Router)
    /**
     * NOTE: do __NOT__ set default current entity here. It is set by
     * {@link file://./../contexts/effects/sync-current-entities-with-url.ts}
     */
    super({
      api: ngCore.inject(Api),
      context$: _contexts.selectors.appContext.asObservable,
      identify: scenario => scenario.id,
      name: ec.Name.Predefined.AdminScenario,
      plugins: {
        additionalFactories: [
          new ds.table.ec.Factory<TypeParams>(() => ({
            rowConfig: ({ entity: scenario }) => ({
              onClick: () => {
                const source = `Table.Row-${scenario.id}.Clicked`
                const url = _contexts.selectors
                  .getUrlForScenario(scenario)
                  .asSignal()

                if (url) {
                  _router.actions.navigate.from(source).dispatch({ url })
                }
              },
            }),
          })),
        ],
        currentList: {
          sortBy: { get: key => key ?? 'name' },
        },
      },
    })
    this.feature.registerEffects(
      effects.syncCurrentEntityWithUrl(this, _router),
    )
  }
}
